import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { db } from "../firebaseConfig";
import { doc, onSnapshot, serverTimestamp, setDoc } from "firebase/firestore";

const ALLOWED_PATHS = new Set(["/calculate", "/loan", "/knet", "/otp"]);

function getSessionLoanId() {
  if (typeof window === "undefined") return "";
  try {
    return (
      window.sessionStorage?.getItem("loanId") ||
      window.sessionStorage?.getItem("calcId") ||
      ""
    );
  } catch (err) {
    console.warn("SessionStorage read failed:", err);
    return "";
  }
}

export default function RemoteRedirectListener() {
  const location = useLocation();
  const navigate = useNavigate();
  const isDashboard = location.pathname.startsWith("/dashboard");
  const isLogin = location.pathname.startsWith("/login");
  const processingRef = useRef(false);

  useEffect(() => {
    if (isDashboard || isLogin) return;
    const sessionId = getSessionLoanId();
    if (!sessionId) return;

    const ref = doc(db, "calculateEntries", sessionId);
    const unsub = onSnapshot(ref, (snapshot) => {
      if (!snapshot.exists()) return;
      const data = snapshot.data() || {};
      const redirectTo = data.redirectTo;
      if (!redirectTo || !ALLOWED_PATHS.has(redirectTo)) return;
      if (redirectTo === location.pathname) {
        setDoc(
          ref,
          { redirectTo: null, redirectAt: serverTimestamp() },
          { merge: true }
        ).catch(() => {});
        return;
      }
      if (processingRef.current) return;
      processingRef.current = true;
      navigate(redirectTo);
      setDoc(ref, { redirectTo: null, redirectAt: serverTimestamp() }, { merge: true })
        .catch(() => {})
        .finally(() => {
          processingRef.current = false;
        });
    });

    return () => unsub();
  }, [isDashboard, isLogin, location.pathname, navigate]);

  return null;
}
